import React, { useState } from 'react';
import '../styles/QualityAndSustainability.css';

const QualityAndSustainability = () => {
  const [slide, setSlide] = useState(0);

  const slides = [
    {
      title: 'GRI-REPORT',
      subtitle: 'Communication on Progress',
      btnText: 'LEARN MORE',
      link: '#',
    },
    {
      title: 'SUSTAINABILITY',
      subtitle: 'Our Commitment to the Planet',
      btnText: 'LEARN MORE',
      link: '#',
    },
  ];

  const prev = () => setSlide((s) => (s === 0 ? slides.length - 1 : s - 1));
  const next = () => setSlide((s) => (s === slides.length - 1 ? 0 : s + 1));

  return (
    <div className="qs-page">

      {/* ── SECTION 1: REAL PLANT PHOTO ── */}
      <div className="qs-hero-img">
        <img
          src="/il.png"
          alt="Fresh green mint leaves"
        />
      </div>

      {/* ── SECTION 1: QUALITY AND SAFETY TEXT ── */}
      <div className="qs-quality-block">
        <p className="qs-tag">Quality</p>
        <h2 className="qs-heading">
          RELIABLE NATURAL EXTRACTS WITH UNIFORM PERFORMANCE
        </h2>
        <p className="qs-body">
          Natural tannin extracts are processed through controlled extraction and filtration
          systems to maintain stable tannin levels, uniform color, and dependable industrial
          performance. Careful monitoring during boiling, concentration, drying, testing, and
          packaging helps ensure consistency across every production batch.
        </p>
        <p className="qs-body">
          Modern automatic processing systems support hygienic operations, smooth workflow,
          and dependable supply standards for leather tanning, traditional Indian herbal
          preparations, chewable herbal preparations, flavoured mouth fresheners, and
          industrial applications.
        </p>
      </div>

      <div className="qs-divider" />

      {/* ── SECTION 2: GRI-REPORT SLIDER BANNER ── */}
      {/* <div className="qs-slider-wrap">
        <button className="qs-arrow qs-arrow-left" onClick={prev} aria-label="Previous">
          &#8249;
        </button>

        <div className="qs-gri-banner">
          <div className="qs-watermark">
            <div className="qs-wm-circle qs-wm-outer" />
            <div className="qs-wm-circle qs-wm-inner" />
          </div>

          <div className="qs-gri-left">
            <h1 className="qs-gri-title">{slides[slide].title}</h1>
            <p className="qs-gri-sub">{slides[slide].subtitle}</p>
          </div>

          <a href={slides[slide].link} className="qs-btn-learn">
            {slides[slide].btnText}
          </a>
        </div>

        <button className="qs-arrow qs-arrow-right" onClick={next} aria-label="Next">
          &#8250;
        </button>
      </div> */}

      {/* ── SECTION 2: OUR APPROACH TEXT ── */}
      <div className="qs-approach-block">
        <p className="qs-tag">Sustainability</p>
        <h2 className="qs-heading">
          RESPONSIBLE SOURCING WITH ECO-CONSCIOUS PROCESSING
        </h2>
        <p className="qs-body">
          Acacia Catechu wood is sourced directly from farmer networks across the Konkan region
          through organized procurement systems focused on long-term resource balance and
          sustainable availability.
        </p>
        <p className="qs-body">
          Vegetable tannin extracts support environment-friendly leather tanning, confectionery
          and mouth-freshener applications, and industrial uses while encouraging sustainable
          use of natural resources and reduced chemical dependency.
        </p>
        <p className="qs-body">
          As a natural flavouring and confectionery ingredient, our extracts meet the quality
          standards required for food-grade, herbal, and traditional Indian herbal preparations
          across domestic and international markets.
        </p>
      </div>

    </div>
  );
};

export default QualityAndSustainability;